export default "__VITE_ASSET__33c281bc__"